import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { PriceBlock } from './PriceBlock';
export function HeroSection() {
  return <section className="relative pt-20 pb-16 md:pt-28 md:pb-24 px-4 bg-cream overflow-hidden" data-id="element-89">
      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-90">
        <motion.h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-8" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} data-id="element-91">
          Cómo dejar de sobrepensar, calmar tu mente y recuperar la paz mental
        </motion.h1>

        <motion.a href="https://claridadmental.shop/cart/53007812624747:1" className="block w-full max-w-2xl mx-auto mb-10 group cursor-pointer" initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} data-id="element-92">
          <div className="relative rounded-2xl overflow-hidden shadow-2xl transition-transform duration-500 group-hover:scale-[1.02] group-hover:shadow-gold-start/20" data-id="element-93">
            <img src="https://cdn.magicpatterns.com/uploads/8eDnC17youuNSfkVnt1QpA/va.jpg" alt="Mega Pack Claridad Mental" className="w-full h-auto object-cover" data-id="element-94" />
            <div className="absolute inset-0 bg-gold-start/0 group-hover:bg-gold-start/10 transition-colors duration-300" data-id="element-95"></div>
          </div>
        </motion.a>

        <motion.p className="text-lg md:text-xl text-brown-light mb-10 max-w-3xl mx-auto leading-relaxed" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} data-id="element-96">
          Descubre un sistema simple inspirado en enseñanzas contemplativas que
          está ayudando a miles de personas a entender su mente, reducir el
          estrés mental y vivir con más claridad.
        </motion.p>

        <motion.div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-8 mb-12" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.6
      }} data-id="element-97">
          {['Sin técnicas complicadas', 'Sin teoría innecesaria', 'Prácticas simples para aplicar cada día'].map((text, i) => <div key={i} className="flex items-center gap-2 text-brown font-medium" data-id="element-98">
              <div className="bg-gold-start/20 p-1 rounded-full" data-id="element-99">
                <Check className="w-4 h-4 text-gold-end" data-id="element-100" />
              </div>
              <span data-id="element-101">{text}</span>
            </div>)}
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.8
      }} className="flex flex-col items-center" data-id="element-102">
          <PriceBlock compact data-id="element-103" />
          <CtaButton text="QUIERO CALMAR MI MENTE AHORA" data-id="element-104" />
        </motion.div>
      </div>

      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-105">
        <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] rounded-full bg-gold-start/5 blur-3xl" data-id="element-106"></div>
        <div className="absolute bottom-[-10%] right-[-10%] w-[40%] h-[40%] rounded-full bg-gold-start/5 blur-3xl" data-id="element-107"></div>
      </div>
    </section>;
}